import {
  SET_PATH,
  SET_ROLE,
  SET_ACTIVE,
  SET_STATUS,
  SET_CATEGORY,
  SET_NAME,
  SET_TYPE,
  SET_ROOT
} from './mutation-types.js'
export default {
  [SET_PATH] (state, data) {
    state.path = data
  },
  [SET_ROLE] (state, data) {
    state.role = data
  },
  [SET_ACTIVE] (state, data) {
    state.activeTab = data
  },
  [SET_STATUS] (state, data) {
    state.status = data
  },
  [SET_CATEGORY] (state, data) {
    state.prjCategory = data
  },
  [SET_NAME] (state, data) {
    state.name = data
  },
  [SET_TYPE] (state, data) {
    state.prjType = data
  },
  [SET_ROOT] (state, data) {
    state.root = data
  }
}
